import PropTypes from "prop-types";

import { t } from "../../../../../../services";
import { alignItems, strCode } from "../../../../../../consts";
import { dateUtil } from "../../../../../../utils";

import { FlexContainers, Paragraph2, WrapperContainer } from "../../../../../../components";
import { InfoText, OverviewSectionSummaryStyled } from "./styled";

export const OverviewSectionSummary = ({ overviewSectionData }) => {
  const {
    campaignName,
    hasNotificationMessage,
    selectedNotificationName,
    startDate,
    startTime,
    hasPushNotificationDate,
    pushNotificationDate,
    pushNotificationTime
  } = overviewSectionData ?? {};

  return overviewSectionData ? (
    <OverviewSectionSummaryStyled
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      gap={8}
      width={"100%"}>
      <Paragraph2>{campaignName}</Paragraph2>
      {hasNotificationMessage && <Paragraph2>{selectedNotificationName?.value}</Paragraph2>}

      <Paragraph2>{dateUtil.formatDateAndTime(startDate, startTime)}</Paragraph2>

      {hasPushNotificationDate && (
        <WrapperContainer
          Container={FlexContainers.FlexColumnStart}
          alignItems={alignItems.start}
          width={"100%"}
          mt={8}>
          <InfoText>{t(strCode.PUSH_NOTIFICATION_INFO)}</InfoText>

          <Paragraph2>
            {dateUtil.formatDateAndTime(pushNotificationDate, pushNotificationTime)}
          </Paragraph2>
        </WrapperContainer>
      )}
    </OverviewSectionSummaryStyled>
  ) : null;
};

OverviewSectionSummary.propTypes = {
  overviewSectionData: {
    campaignName: PropTypes.string.isRequired,
    hasNotificationMessage: PropTypes.bool.isRequired,
    selectedNotificationName: PropTypes.object,
    startDate: PropTypes.instanceOf(Date).isRequired,
    startTime: PropTypes.instanceOf(Date).isRequired,
    hasPushNotificationDate: PropTypes.bool.isRequired,
    pushNotificationDate: PropTypes.instanceOf(Date),
    pushNotificationTime: PropTypes.instanceOf(Date)
  }
};
